module.exports = __webpack_public_path__ + "static/img/bg_shouye.0d801492.jpg";